
export default function AssessmentFlow() {
  const steps = [
    {
      number: '01',
      title: 'お問い合わせ',
      description: 'LINE（おすすめ）、メール、お電話のいずれかでお気軽にお問い合わせください。写真をお送りいただくとスムーズです。',
      icon: 'ri-phone-line',
    },
    {
      number: '02',
      title: '日程調整',
      description: 'ご都合の良い日時をお伺いし、出張査定の日程を調整いたします。最短で即日対応も可能です。',
      icon: 'ri-calendar-check-line',
    },
    {
      number: '03',
      title: '出張査定',
      description: '専門鑑定士がご自宅までお伺いし、その場で丁寧に査定いたします。出張費用は一切かかりません。',
      icon: 'ri-car-line',
    },
    {
      number: '04',
      title: '査定額提示',
      description: '査定結果をその場でご説明し、買取金額をご提示いたします。ご納得いただけない場合はキャンセルも可能です。',
      icon: 'yen',
    },
    {
      number: '05',
      title: 'お支払い',
      description: 'ご了承いただけましたら、その場で現金にてお支払いいたします。必要書類のご記入をお願いいたします。',
      icon: 'ri-hand-coin-line',
    },
  ];

  return (
    <section id="flow" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-block bg-samurai-red/10 px-6 py-2 rounded-full mb-6">
            <p className="text-samurai-red font-bold text-base lg:text-lg whitespace-nowrap">FLOW</p>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black text-samurai-dark mb-6 font-serif">
            査定・買取の流れ
          </h2>
          <p className="text-xl lg:text-2xl text-samurai-gray max-w-3xl mx-auto leading-relaxed">
            お問い合わせから買取完了まで、<strong>最短即日（関東）～</strong>対応いたします
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-1 bg-samurai-gold/30 transform -translate-x-1/2"></div>

          <div className="space-y-12 lg:space-y-16">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`flex flex-col lg:flex-row items-center gap-8 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                  <div className="bg-white rounded-2xl p-8 lg:p-10 shadow-lg border-2 border-gray-100 hover:border-samurai-gold transition-all duration-300">
                    <div className={`flex items-center gap-4 mb-4 ${index % 2 === 0 ? 'lg:justify-end' : 'lg:justify-start'}`}>
                      <div className="w-16 h-16 bg-samurai-gold/10 rounded-full flex items-center justify-center">
                        {step.icon === 'yen' ? (
                          <span className="text-4xl font-black text-samurai-gold">￥</span>
                        ) : (
                          <i className={`${step.icon} text-3xl text-samurai-gold`}></i>
                        )}
                      </div>
                      <span className="text-6xl lg:text-7xl font-black text-samurai-gold/20 font-serif">
                        {step.number}
                      </span>
                    </div>
                    <h3 className="text-2xl lg:text-3xl font-black text-samurai-dark mb-4 font-serif whitespace-nowrap">
                      {step.title}
                    </h3>
                    <p className="text-lg lg:text-xl text-samurai-gray leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                <div className="flex-1 hidden lg:block"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-samurai-red to-samurai-red/80 rounded-2xl p-8 lg:p-12 text-white">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center">
              <i className="ri-time-line text-6xl"></i>
            </div>
            <h3 className="text-3xl lg:text-4xl font-black mb-4 font-serif whitespace-nowrap">
              最短即日対応
            </h3>
            <p className="text-xl lg:text-2xl mb-6 leading-relaxed max-w-3xl mx-auto">
              お急ぎの方もご安心ください。お問い合わせいただいた当日に査定・買取が可能です。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://lin.ee/Bi3KvRO"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex flex-col items-center gap-1 bg-green-500 text-white px-10 py-4 rounded-lg font-bold text-xl hover:bg-green-600 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
              >
                <span className="flex items-center gap-3">
                  <i className="ri-line-fill text-2xl"></i>
                  LINEで問い合わせ
                </span>
                <span className="text-yellow-300 text-sm font-bold whitespace-nowrap">
                  おすすめ（返答率100％）
                </span>
              </a>
              <a
                href="tel:070-8453-9292"
                className="inline-flex items-center gap-3 bg-white text-samurai-red px-10 py-5 rounded-lg font-bold text-xl hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill text-2xl"></i>
                今すぐお電話
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
